import { formatLogTime, levelTone, type LogLineView } from './logs';
import { color, font, status } from './tokens';

const grid = {
  display: 'grid',
  gridTemplateColumns: '150px 130px 64px minmax(0, 1fr)',
  gap: 12,
  alignItems: 'baseline',
  padding: '7px 20px',
  fontSize: 13,
} as const;

/** Log lines as listed by the server (newest first), with a header row. */
export function LogLines({ lines, now }: { lines: LogLineView[]; now?: Date }) {
  return (
    <div role="table" aria-label="Log lines" style={{ overflowX: 'auto' }}>
      <div role="rowgroup">
        <div
          role="row"
          style={{ ...grid, fontSize: 12, fontWeight: 600, color: color.textMuted, minWidth: 640 }}
        >
          <span role="columnheader">Time</span>
          <span role="columnheader">Service</span>
          <span role="columnheader">Level</span>
          <span role="columnheader">Message</span>
        </div>
      </div>
      <div role="rowgroup">
        {lines.map((l, i) => {
          const tone = l.level ? levelTone(l.level) : undefined;
          return (
            <div
              role="row"
              key={i}
              style={{ ...grid, borderTop: `1px solid ${color.rowRule}`, minWidth: 640 }}
            >
              <span role="cell" style={{ fontFamily: font.mono, color: color.textMuted }}>
                {formatLogTime(l.at, now)}
              </span>
              <span role="cell" style={{ overflowWrap: 'anywhere' }}>
                {l.service ?? '–'}
              </span>
              <span role="cell">
                {tone && (
                  <span
                    data-tone={tone}
                    style={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      minWidth: 48,
                      padding: '1px 6px',
                      borderRadius: 4,
                      font: `600 11px ${font.mono}`,
                      background: status[tone].bg,
                      color: status[tone].fg,
                    }}
                  >
                    {l.level!.toUpperCase()}
                  </span>
                )}
              </span>
              <span
                role="cell"
                style={{ fontFamily: font.mono, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
              >
                {l.line}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
